export enum UserModeEnum {
  OWNER = 'owner',
  SITTER = 'sitter',
  UNAUTHED = 'unauthed',
}
